import { Heading } from '@/components/common/Heading';
import { cn } from '@/lib/cn';

interface DashboardHeroProps {
  className?: string;
  Icon?: React.ElementType;
  iconClassName?: string;
  title: string;
  description: string | React.ReactNode;
  actionText?: string;
  action?: React.ReactNode;
}

export const DashboardHero = ({
  className,
  Icon,
  iconClassName,
  title,
  description,
  actionText,
  action,
}: DashboardHeroProps) => {
  return (
    <div className={cn('flex w-full flex-col gap-7.5', className)}>
      {Icon && (
        <Icon
          className={cn('text-primary size-20 lg:size-25', iconClassName)}
        />
      )}

      <div>
        <Heading as="h1" className="text-secondary mb-3 text-left capitalize">
          {title}
        </Heading>

        {typeof description === 'string' ? <p>{description}</p> : description}
      </div>

      {actionText && (
        <Heading asChild size="h4" className="text-left">
          <p>{actionText}</p>
        </Heading>
      )}

      {action && action}
    </div>
  );
};
